import { render } from "./RfcBasePage.vue?vue&type=template&id=1c4ae5ad"
import script from "./RfcBasePage.vue?vue&type=script&lang=js"
export * from "./RfcBasePage.vue?vue&type=script&lang=js"

import exportComponent from "/root/mentoringplatform-acm/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__